/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InclusaoBeneficiarioConsultaAliases {
  ACTION_NOVA_INCLUSAO = 'action-nova-inclusao',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  CONTEXTUAL_BAR_INCLUSAO = 'contextual-bar-inclusao',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_2 = 'fetch-2',
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  PANEL_1 = 'panel-1',
  PANEL_INCLUSAO_BENEFICIARIO = 'panel-inclusao-beneficiario',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
}
export { InclusaoBeneficiarioConsultaAliases };
